import React, { FC } from "react";
import { FlexSpan, TitleText } from "@evergis/ui";

import { useDialogContext } from "../FullScreenDialog";
import { AttributesHeader as AttributesHeaderContainer, Description, TitleIcon } from "../styled";
import { AttributesVisibilityHeader } from "./AttributesVisibilityHeader";
import { AttributesBlockTitle } from "./styled";

import { AttributesProps } from "./Attributes";

type AttributesHeaderProps = Pick<
  AttributesProps,
  | "allAttributes"
  | "allAttributesLabel"
  | "toggleAllAttributes"
  | "isEdit"
  | "showTitle"
  | "showDescription"
  | "headerConfiguration"
  | "className"
>;

export const AttributesHeader: FC<AttributesHeaderProps> = ({
  showTitle,
  showDescription = true,
  allAttributes,
  allAttributesLabel,
  toggleAllAttributes,
  isEdit,
  headerConfiguration,
  className,
  children,
}) => {
  const { attributes } = useDialogContext();
  const { icon, label, description } = headerConfiguration || attributes;

  return (
    <AttributesHeaderContainer className={className}>
      {showTitle && (
        <AttributesBlockTitle>
          <FlexSpan>
            <TitleIcon kind={icon} />
            <TitleText>{label}</TitleText>
          </FlexSpan>
        </AttributesBlockTitle>
      )}
      {showDescription && description && <Description>{description}</Description>}
      {children}
      {toggleAllAttributes && (
        <AttributesVisibilityHeader
          isEdit={isEdit}
          toggleAllAttributes={toggleAllAttributes}
          allAttributes={allAttributes}
          allAttributesLabel={allAttributesLabel}
        />
      )}
    </AttributesHeaderContainer>
  );
};
